"use strict";

exports.__esModule = true;

var arithmetic_1 = require("./arithmetic");

var Function_1 = require("./Function");

var HTML_1 = require("./HTML");

var Map_1 = require("./Map");

var replicator_1 = require("./replicator");

var transforms = [HTML_1["default"], Function_1["default"], arithmetic_1["default"], Map_1["default"]];
var replicator = new replicator_1["default"]();
replicator.addTransforms(transforms);

function Encode(data) {
  return JSON.parse(replicator.encode(data));
}

exports.Encode = Encode;

function Decode(data) {
  return replicator.decode(JSON.stringify(data));
}

exports.Decode = Decode;